/**
 * Roles del equipo de la agencia (custom claims de Firebase Auth):
 *   admin  → puede todo, incluido dar o quitar roles.
 *   editor → puede todo (marcas, campañas, landings, accesos de clientes) menos administrar
 *            roles y las cuentas del equipo.
 * Sin rol = cliente.
 */
export type StaffRole = 'admin' | 'editor';

export const STAFF_ROLES: readonly StaffRole[] = ['admin', 'editor'];

export const ROLE_LABEL: Record<StaffRole, string> = { admin: 'Admin', editor: 'Editor' };

/** Rol a partir de los claims; solo cuenta el valor booleano true. */
export function roleFromClaims(
  claims: Record<string, unknown> | undefined | null,
): StaffRole | null {
  if (claims?.admin === true) return 'admin';
  if (claims?.editor === true) return 'editor';
  return null;
}

/** Claims nuevos con el rol indicado, conservando los demás. */
export function claimsWithRole(
  claims: Record<string, unknown> | undefined | null,
  role: StaffRole | null,
): Record<string, unknown> {
  const next = { ...(claims ?? {}) };
  delete next.admin;
  delete next.editor;
  if (role) next[role] = true;
  return next;
}
